import { useEffect,useState } from 'react';
import {useLocation} from 'react-router-dom';
import useAPI from "../Hooks/useAPI";
import { useUser } from '../Context/UserContext';

const usePageUserTracking = () => {
const location = useLocation();
 const { user, hasRole } = useUser();

 const { addUserTracking } = useAPI();

 const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

 useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const metadata = JSON.stringify({
    page: location.pathname,
    device: isMobile ? "mobile" : "desktop"
  });

 useEffect(() => {
    if (user && user.id && metadata) {
      addUserTracking(user.id, "Page Visited", user.id, metadata);
    }
  }, [user, location.pathname, metadata, addUserTracking]);
};




export default usePageUserTracking;